import React, { Component } from "react";
import "../LandingPage/LandingPageStyleSheet.css";
import dayjs from "dayjs";
import HWLog from "../HWLibrary/HWLog";
// import { InView } from 'react-intersection-observer'
// import HWLog from "../HWLibrary/HWLog";

class ConversationListCell extends Component {
  render() {
    let lastMessage =
      (this.props.conversation.lastMessage &&
        this.props.conversation.lastMessage.text) ||
      "";
    let timeStampString =
      this.props.conversation &&
      Math.trunc(this.props.conversation.createdOn / 1000);
    // let displayTime = (timeStampString) ? dayjs.unix(timeStampString).format("MMM D, YYYY h:mm a") : null;
    let displayTime = timeStampString
      ? dayjs.unix(timeStampString).format("DD MMM h:mm a")
      : null;
    let agentDisplayName =
      this.props.conversation.agentInfo &&
      this.props.conversation.agentInfo.firstName &&
      this.props.conversation.agentInfo.lastName
        ? this.props.conversation.agentInfo.firstName +
          " " +
          this.props.conversation.agentInfo.lastName
        : "BOT";
    let agentDisplayInitials =
      this.props.conversation.agentInfo &&
      this.props.conversation.agentInfo.firstName &&
      this.props.conversation.agentInfo.lastName
        ? this.props.conversation.agentInfo.firstName.charAt(0) +
          "" +
          this.props.conversation.agentInfo.lastName.charAt(0)
        : "B";
    let statusColor =
      this.props.conversation &&
      this.props.conversation.agentInfo &&
      this.props.conversation.agentInfo.isActive === true
        ? "#00cc00"
        : "#e60000";
    let placeholderPic =
      this.props.config.configDetails.chatCellIcon &&
      this.props.config.configDetails.chatCellIcon !== ""
        ? this.props.config.configDetails.chatCellIcon
        : "https://static.intercomassets.com/avatars/746691/square_128/custom_avatar-1537388943.png?1537388943";
    // let agentProfilePic =
    //   (this.props.conversation &&
    //     this.props.conversation.agentInfo &&
    //     this.props.conversation.agentInfo.userProfilePic) ||
    //   placeholderPic;
    let styleBkg = {
      paddingTop: "16%",
      width: "33px",
      height: "33px",
      color: "#fff",
      textAlign: "center",
      borderRadius: "50%",
      verticalAlign: "middle",
      fontSize: "17px",
      /*"fontWeight":"bold",*/ filter: "brightness(130%)",
    };
    const colors = ["#c797fc", "#ff9ba6", "#ff91e2", "#66b784"];
    styleBkg.background = colors[Math.floor(Math.random() * colors.length)];
    return (
      // <InView onChange={(inView, entry) => { this.onViewStateChange(inView) }} >
      //     {({ inView, ref, entry }) => (
      <div className="s360-conversation-history-list-cell">
        <div
          className="s360-conversation-history-container"
          style={this.conversationStyle()}
          onClick={this.showConversation}
        >
          <div className="s360-conversation-history-agent-image-container">
            <div className="s360-conversation-history-agent-image-cell">
              <div style={styleBkg}>{agentDisplayInitials}</div>
              {/* <img src={agentProfilePic} className="s360-conversation-history-agent-image-cell-image" width="30px" height="30px"  /> */}
              <div className="s360-conversation-header-agent-ping-status-container">
                <div
                  className="s360-conversation-list-header-agent-ping-status"
                  style={{ backgroundColor: statusColor }}
                ></div>
              </div>
            </div>
          </div>
          <div className="s360-conversation-history-agent-detail-container">
            <div
              className="s360-conversation-history-agent-detail-cell"
              style={this.agentDetailStyle()}
            >
              <div
                className="s360-conversation-history-agent-details-name"
                style={this.agentNameStyle()}
              >
                {agentDisplayName}
              </div>
              <div
                className="s360-conversation-history-agent-message-time"
                style={this.agentTimeStyle()}
              >
                {displayTime}
              </div>
            </div>
            <div className="s360-conversation-history-agent-message-container">
              <div className="s360-conversation-history-agent-message-content">
                {lastMessage.length > 5
                  ? lastMessage.substring(0, 100)
                  : lastMessage}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="s360-conversation-history-time-container">
                                <div className="s360-conversation-history-agent-message-time" style={this.agentTimeStyle()}>
                                    {displayTime}
                                </div>
                            </div> */}
      </div>
      //     )}
      // </InView>
    );
  }

  conversationStyle = () => {
    return {
      backgroundColor: this.props.config.designDetails.pageBackgroundColor,
    };
  };

  showConversation = () => {
    this.props.landingPageActions.checkAndStartNewConversationCometd(
      this.props.conversation
    );
  };

  agentDetailStyle = () => {
    return {
      backgroundColor: this.props.config.designDetails.pageBackgroundColor,
      // display: "flex",
      // flexDirection: "column",
      // marginLeft: "10px"
    };
  };

  agentNameStyle = () => {
    return {
      color: this.props.config.designDetails.agentNameColor,
    };
  };

  agentTimeStyle = () => {
    return {};
  };

  onViewStateChange = (inView) => {
    if (inView) {
      this.startFetchingHealthPings();
    } else {
      this.stopFetchingHealthPings();
    }
  };

  // MARK: AGENT HEALTH PING:
  // Start fetching health ping for every 10 seconds. Stop heath ping time on component unmount.
  agentHealthPingTimerId = null;
  startFetchingHealthPings = () => {
    let sessionId =
      this.props.conversation && this.props.conversation.sessionId;
    if (!sessionId) {
      HWLog.warn("No Session Id Available To Fetch Agent Health Ping: ");
      return;
    }
    this.props.fetchAgentHealthPing(sessionId);
    this.agentHealthPingTimerId = setInterval(async () => {
      this.props.fetchAgentHealthPing(sessionId);
    }, 2000);
  };

  stopFetchingHealthPings = () => {
    if (this.agentHealthPingTimerId) {
      clearInterval(this.agentHealthPingTimerId);
    }
  };
}

export default ConversationListCell;
